import { Sparkles, Smile, Wallet, Leaf } from "lucide-react";
import { T } from "@/i18n";

const PARTS = [
  { key: "esperienza", label: "Esperienza", icon: Sparkles },
  { key: "comfort", label: "Comfort", icon: Smile },
  { key: "budget", label: "Budget", icon: Wallet },
  { key: "impatto", label: "Impatto", icon: Leaf },
];

const Gauge = ({ score }) => {
  const r = 70, c = 2 * Math.PI * r, off = c - (Math.max(0, Math.min(100, score)) / 100) * c;
  return (
    <div className="relative h-48 w-48 shrink-0">
      <svg viewBox="0 0 180 180" className="h-full w-full -rotate-90">
        <circle cx="90" cy="90" r={r} fill="none" stroke="#d1fae5" strokeWidth="14" />
        <circle cx="90" cy="90" r={r} fill="none" stroke="url(#tisg)" strokeWidth="14" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={off} style={{ transition: "stroke-dashoffset 1.2s ease" }} />
        <defs><linearGradient id="tisg"><stop offset="0%" stopColor="#047857" /><stop offset="100%" stopColor="#34d399" /></linearGradient></defs>
      </svg>
      <div className="absolute inset-0 grid place-items-center text-center">
        <div>
          <p data-testid="tis-score-value" className="font-display text-5xl font-extrabold text-gray-900">{score}</p>
          <p className="text-xs font-semibold uppercase tracking-widest text-emerald-700">TIS / 100</p>
        </div>
      </div>
    </div>
  );
};

export const TisScore = ({ tis = {} }) => (
  <div id="impact-score" data-testid="tis-score-gauge" className="print-break rounded-3xl border border-emerald-100 bg-white p-8 md:p-10">
    <p className="text-xs font-semibold uppercase tracking-widest text-emerald-700">TS Impact Score</p>
    <div className="mt-6 flex flex-col gap-10 md:flex-row md:items-center">
      <Gauge score={tis.score ?? 0} />
      <div className="flex-1">
        <h3 data-testid="tis-label" className="font-display text-2xl font-semibold text-gray-900">{tis.label}</h3>
        <p className="mt-3 leading-relaxed text-gray-600">{tis.explanation}</p>
        <div className="mt-6 grid gap-4 sm:grid-cols-2">
          {PARTS.map(({ key, label, icon: Icon }) => {
            const v = tis.breakdown?.[key] ?? 0;
            return (
              <div key={key} data-testid={`tis-breakdown-${key}`}>
                <div className="flex items-center justify-between text-sm">
                  <span className="flex items-center gap-2 font-medium text-gray-700"><Icon className="h-4 w-4 text-emerald-600" /><T>{label}</T></span>
                  <span className="font-display font-semibold text-gray-900">{v}</span>
                </div>
                <div className="mt-2 h-1.5 rounded-full bg-emerald-50">
                  <div className="h-full rounded-full bg-emerald-500" style={{ width: `${v}%` }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </div>
);
